// ContactCard — French. 'Edit', 'Save', 'Cancel', 'Saving…', 'not set' and 'not collected' live
// in common.fr.ts and are not repeated. 'tier', 'cadence', 'do not contact' and the three
// principal words are PersonPage's too — the same French, so the duplicate is silent; 'read',
// 'declared', 'estimated', 'computed', 'confidence' are the method words ReviewPage, SignalsZone
// and ProfileZone already speak, byte-identical here so this card reads French on its own.
//
// The cell names and every token come from `src/shared/person-raster.v1.ts` through
// `personLabelFor`, never from here.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Contact': 'Coordonnées',
  'the person’s own columns and the raster’s contact cells · an edit writes a declared fact':
    'les colonnes propres de la personne et les cellules de contact de la grille · une modification écrit un fait déclaré',
  'Ask Surfe': 'Demander à Surfe',
  'Asking…': 'Demande en cours…',
  'Ask Surfe for the professional e-mail — one credit; the answer is a proposal you hold or refuse.':
    'Demander à Surfe l’e-mail professionnel — un crédit ; la réponse est une proposition que vous retenez ou refusez.',
  'This person asked not to be contacted; nothing is bought about them.': 'Cette personne a demandé à ne pas être contactée ; rien n’est acheté à son sujet.',
  'e-mail credits left': 'crédits e-mail restants',
  'a broker’s assertion waits for your click; it is never held on arrival': 'l’affirmation d’un courtier attend votre clic ; elle n’est jamais retenue à l’arrivée',
  'waits in Review': 'attend en Revue',
  'Surfe says': 'Surfe dit',
  'more cells filed beside it': 'autres cellules déposées à côté',
  'cells filed from the answer': 'cellules déposées depuis la réponse',
  'Paid Surfe enrichment is off (setting surfe.email_enrichment); nothing was bought.': 'L’enrichissement Surfe payant est désactivé (réglage surfe.email_enrichment) ; rien n’a été acheté.',
  'Surfe has no e-mail credits left; nothing was bought.': 'Surfe n’a plus de crédits e-mail ; rien n’a été acheté.',
  'Surfe refused the call (HTTP {n}); nothing was bought.': 'Surfe a refusé l’appel (HTTP {n}) ; rien n’a été acheté.',
  'Surfe could not be reached; nothing was bought.': 'Surfe était injoignable ; rien n’a été acheté.',
  'Surfe answered an error (HTTP {n}); nothing was bought.': 'Surfe a répondu une erreur (HTTP {n}) ; rien n’a été acheté.',
  'No held current employer — Surfe is asked only about a person whose employer is on the record.': 'Pas d’employeur actuel retenu — Surfe n’est interrogé qu’au sujet d’une personne dont l’employeur figure au registre.',
  'A work e-mail is already held; nothing was asked.': 'Un e-mail professionnel est déjà retenu ; rien n’a été demandé.',
  'Neither a LinkedIn URL nor a last name with an employer domain: Surfe cannot identify them.': 'Ni URL LinkedIn ni nom de famille avec un domaine d’employeur : Surfe ne peut pas identifier la personne.',
  'Surfe knows no professional e-mail for this person; the answer is kept as a snapshot.': 'Surfe ne connaît pas d’e-mail professionnel pour cette personne ; la réponse est conservée comme instantané.',
  'Surfe is still working; nothing was filed yet.': 'Surfe travaille encore ; rien n’a été déposé pour l’instant.',
  'Surfe could not enrich this person; the call is on the ledger.': 'Surfe n’a pas pu enrichir cette personne ; l’appel figure au journal.',

  // the marks a column-only value takes
  'typed by the operator; no fact on the cell yet': 'saisi par l’opérateur ; pas encore de fait sur la cellule',
  'written by an import; nobody has held it': 'écrit par un import ; personne ne l’a retenu',
  // un fait COURANT que personne n’a retenu : ◇ sur la valeur, le mot à côté
  'not held': 'non retenu',
  'a fact on the cell that nobody has held': 'un fait sur la cellule que personne n’a retenu',
  'column': 'colonne',
  'operator': 'opérateur',
  'agent': 'agent',
  'import': 'import',

  // the methods
  'read': 'lecture',
  'declared': 'déclaré',
  'estimated': 'estimé',
  'computed': 'calculé',
  'confidence': 'confiance',
  'setting': 'réglage',

  // the reach rows
  'Type one or more addresses; the first is the work e-mail the raster holds. Clearing retracts.':
    'Saisir une ou plusieurs adresses ; la première est l’e-mail professionnel que la grille retient. Vider rétracte.',
  'one or more addresses, comma-separated': 'une ou plusieurs adresses, séparées par des virgules',
  'Type one or more numbers; the first is the work phone the raster holds. Clearing retracts.':
    'Saisir un ou plusieurs numéros ; le premier est le téléphone professionnel que la grille retient. Vider rétracte.',
  'one or more numbers, comma-separated': 'un ou plusieurs numéros, séparés par des virgules',
  'Paste the profile URL — linkedin.com/in/…; the profile itself is never read.':
    'Coller l’URL du profil — linkedin.com/in/… ; le profil lui-même n’est jamais lu.',
  'The canton is read by a run or computed from the employer; there is no column to type into.':
    'Le canton est lu par une passe ou calculé depuis l’employeur ; il n’y a pas de colonne à saisir.',
  'The commune of the person’s place of work, as the source spells it — not a domicile. Clearing retracts.':
    'La commune du lieu de travail, telle que la source l’écrit — pas un domicile. Vider rétracte.',
  'the commune as the source spells it': 'la commune telle que la source l’écrit',
  'Clearing a field retracts the claim; the record keeps its history.':
    'Vider un champ rétracte l’affirmation ; le dossier garde son historique.',

  // the settings rows
  'language': 'langue',
  'The language every draft to this person is written in.': 'La langue dans laquelle chaque brouillon à cette personne est écrit.',
  'Formal or informal address — the writing profile suggests, you decide.':
    'Vous ou tu — le profil d’écriture suggère, vous décidez.',
  'read from their own lines; nobody has held it': 'lu dans leurs propres lignes ; personne ne l’a retenu',
  '{n} lines': '{n} lignes',
  'Declare': 'Déclarer',
  'Declare the register the correspondence supports; every draft to them is then written in it.':
    'Déclarer le registre que la correspondance soutient ; chaque brouillon qui leur est adressé s’écrit ensuite dans ce registre.',
  'tier': 'niveau',
  'A, B or C — how much of your attention this person gets; the cadence follows it.':
    'A, B ou C — la part de votre attention que reçoit cette personne ; la cadence en découle.',
  'cadence': 'cadence',
  'Days between touches before this person counts as cooling.': 'Jours entre deux contacts avant que cette personne compte comme refroidissant.',
  'do not contact': 'ne pas contacter',
  'Lift the block: drafts and sequences may address this person again.':
    'Lever le blocage : les brouillons et les séquences peuvent de nouveau s’adresser à cette personne.',
  'Set the block: no draft and no sequence addresses this person until it is lifted.':
    'Poser le blocage : aucun brouillon et aucune séquence ne s’adresse à cette personne tant qu’il n’est pas levé.',
  'Lift': 'Lever',
  'Set': 'Poser',
  'yes': 'oui',
  'no': 'non',
}, 'ContactCard');
